import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  ref: "articleRef"
}
const _hoisted_2 = { class: "c-hero" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "c-hero__wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_Grid = _resolveComponent("Grid")!
  const _component_RichText = _resolveComponent("RichText")!

  return (_openBlock(), _createElementBlock("div", { key: _ctx.slug }, [
    (_ctx.requestState.status === 'loading')
      ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.requestState.status === 'ready' && _ctx.article)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.article.image)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "c-hero__image",
                  src: 
            _ctx.imageUrlBuilder
              .image(_ctx.article.image)
              .width(1200)
              .auto('format')
              .url()
          
                }, null, 8, _hoisted_3))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Grid, { size: "md" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.formatDateLong(_ctx.article.date / 1000)) + " ", 1),
                  _createVNode(_component_PageTitle, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.article.title), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          (_ctx.article.body)
            ? (_openBlock(), _createBlock(_component_RichText, {
                key: 0,
                blocks: _ctx.article.body,
                gridSize: "md",
                class: "pb-4xl"
              }, null, 8, ["blocks"]))
            : _createCommentVNode("", true)
        ], 512))
      : _createCommentVNode("", true)
  ]))
}